
















































import {Component, Vue, Watch} from 'vue-property-decorator';
import {Action, Getter} from 'vuex-class';

@Component({
  components: {},
})
export default class InfoDialog extends Vue {
  @Action('catchments/setWelcomeDialog') private setWelcomeDialog!: any;

  @Getter('catchments/welcomeDialog') private welcomeDialog!: boolean;
  @Getter('auth/anonymous') private anonymous!: boolean;

  get dialog() {
    return this.welcomeDialog && this.anonymous;
  }

  set dialog(val: any) {
    this.setWelcomeDialog(val);
  }
}
